<script>
  export let logo = "";
  export let title = "";
  let retry = 0;

  function getInitials(name) {
    if (!name || typeof name !== "string") return "WA";
    return name
      .split(" ")
      .map((str) => str[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  }
  function reloadImage() {
    logo = "";
    setTimeout(() => {
      if (retry <= 3) {
        let img = new Image();
        img.src = this.src;
        img.onerror = reloadImage;
        retry += 1;
        console.log(retry);
      }
    }, 500);
  }
</script>

<div class="logo-container">
  {#if logo}
    <img
      src={"https://cdn.wa.link/" + logo}
      alt="thumbnail"
      width="80"
      height="80"
      on:error={reloadImage}
    />
  {:else}
    <div class="dot">{getInitials(title)}</div>
  {/if}
</div>

<style>
  .logo-container {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dot {
    height: 80px;
    width: 80px;
    background-color: #ccc;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.4rem;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
  img {
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
</style>
